import React from "react";
import {observable} from "mobx";
import { isInvalidoCodigoContainer } from "../../../../utils/validadores"

export default class CabotagemStore {

    @observable listaNovas;
    @observable listaArquivos;

    @observable erroImportXML;
    @observable xmlVazio;
    @observable validandoXML;
    @observable salvando;

    @observable navioSelecionado;

    constructor(service) {
        this.listaNovas = [];
        this.listaArquivos = [];

        this.salvando = false;

        this.navioSelecionado = false;

        this.service = service;
    };

    guardaXML = (event) => {
        this.salvando = true;
        this.erroImportXML = false;
        this.xmlVazio = false;
        this.xmlFileData = event.target.files[0];
        let data = new FormData();
        data.append('file', this.xmlFileData);
        this.service.xmlImporta(data).then(response => {
            this.salvando = false;
            if (response.data.length>0) {
                response.data.map(d => {
                    if(this.validarXML(d)){
                        this.listaNovas.push(d);
                    }else{
                        this.setErroImportXML()
                        return
                    }
                });
                if(!this.erroImportXML) this.listaArquivos.push({nomeArquivo: this.xmlFileData.name.replace(/[^a-zA-Z0-9\.]/g, "")});
            } else {
                this.xmlVazio = true;
            }
        }).catch(err => { console.log(err); this.jsonFile = null; this.setErroImportXML(); })
            .finally( () =>  this.validandoXML = false)
    };

    setErroImportXML = () => {
        this.erroImportXML = true;
    };

    validarXML = (d) => {
        if(!d.Cte || d.Cte === "" || d.Cte.length > 200) return false
        if(!d.Chave || d.Chave === "" || d.Chave.length < 44 || d.Chave.length > 44 || !(/^[0-9]*$/g).test(d.Chave)) return false
        if(!d.Cntr || d.Cntr === "" || isInvalidoCodigoContainer(d.Cntr)) return false

        return true
    }

    setNavio = (event) => {
        if (event)
            this.navioSelecionado = event;
        else
            this.navioSelecionado = false;
    };

};


// WEBPACK FOOTER //
// ./src/modules/liberacoes/cabotagem/stores/CabotagemImportarXLSStore.js